export const AuthWalletIcon = () => {
  return (
    <svg
      width="120"
      height="120"
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_7824_71127)">
        <path
          d="M120 60C120 26.8629 93.1371 0 60 0C26.8629 0 0 26.8629 0 60C0 93.1371 26.8629 120 60 120C93.1371 120 120 93.1371 120 60Z"
          fill="url(#paint0_linear_7824_71127)"
        />
        <path
          d="M33.75 49.011V71.307C33.75 74.5923 35.0551 77.7429 37.3781 80.066C39.7011 82.389 42.8518 83.694 46.137 83.694H75.867C78.2772 83.6933 80.6349 82.9897 82.6512 81.6692C84.6675 80.3488 86.2549 78.469 87.219 76.26H74.625C71.6684 76.26 68.8328 75.0855 66.7422 72.9948C64.6515 70.9042 63.477 68.0687 63.477 65.112V55.203C63.477 52.2464 64.6515 49.4108 66.7422 47.3202C68.8328 45.2295 71.6684 44.055 74.625 44.055H87.219C86.2543 41.8461 84.6662 39.9666 82.6493 38.6467C80.6324 37.3268 78.2744 36.6239 75.864 36.624H46.134C42.8493 36.6248 39.6994 37.9302 37.377 40.2532C35.0546 42.5761 33.75 45.7263 33.75 49.011Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M68.4316 55.2027V65.1117C68.4316 68.5317 71.2066 71.3067 74.6266 71.3067H87.0166C90.4366 71.3067 93.2086 68.5347 93.2086 65.1117V55.2027C93.2086 51.7827 90.4336 49.0107 87.0136 49.0107H74.6266C71.2066 49.0107 68.4346 51.7827 68.4346 55.2027H68.4316ZM80.8216 60.1587C80.8216 61.1446 80.43 62.09 79.733 62.7871C79.0359 63.4841 78.0905 63.8757 77.1046 63.8757C76.1188 63.8757 75.1734 63.4841 74.4763 62.7871C73.7793 62.09 73.3876 61.1446 73.3876 60.1587C73.3876 59.1729 73.7793 58.2275 74.4763 57.5304C75.1734 56.8334 76.1188 56.4417 77.1046 56.4417C78.0905 56.4417 79.0359 56.8334 79.733 57.5304C80.43 58.2275 80.8216 59.1729 80.8216 60.1587Z"
          fill="white"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_7824_71127"
          x1="60"
          y1="0"
          x2="60"
          y2="120"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#60BFEF" />
          <stop offset="1" stopColor="#0094FE" />
        </linearGradient>
        <clipPath id="clip0_7824_71127">
          <rect width="120" height="120" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
